export default [
  {
    path: '/app/qr-codes',
    name: 'QrCodes',
    component: () => import('@/views/QrCodes/Index.vue'),
    meta: {
      pageTitle: 'QR Kod Yönetimi',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'QR_CODE_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/qr-codes/add',
    name: 'QrCodeAdd',
    component: () => import('@/views/QrCodes/Add.vue'),
    meta: {
      pageTitle: 'QR Kod Yönetimi',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/qr-codes',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'QR_CODE_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/qr-codes/edit/:id',
    name: 'QrCodeEdit',
    component: () => import('@/views/QrCodes/Edit.vue'),
    meta: {
      pageTitle: 'QR Kod Yönetimi',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/qr-codes',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'QR_CODE_EDIT',
      action: 'read',
    },
  },
]
